import { Component, OnInit, signal } from '@angular/core';
import { AuthService } from 'src/app/auth/services/auth.service';
import { UserService } from 'src/app/views/users/services/user.service';

@Component({
  standalone: false,
  selector: 'app-highlighter',
  templateUrl: './highlighter.component.html',
  styleUrls: ['./highlighter.component.scss']
})
export class HighlighterComponent implements OnInit {
  currentUser: any;
  userDetails = signal<any>(null);

  constructor(
    private userService: UserService,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.currentUser = this.authService.currentUserValue;
    this.getUser();
  }

  getUser(){
    this.userService.getUserInfo({}).subscribe((res: any) => {
      this.userDetails.set(res.data[0]);
    });
  }

}
